"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_1 = require("../../Button");
var IconSymbols_1 = require("../../../generated/IconSymbols");
var enums_1 = require("../../../enums");
var ListingItem = function (props) {
    var text = props.text, removeFn = props.removeFn, itemId = props.itemId, href = props.href, linkNewWindow = props.linkNewWindow;
    return (0, jsx_runtime_1.jsxs)("li", __assign({ className: "listing-view__item animated fpZoomIn speed-4" }, { children: [href ?
                (0, jsx_runtime_1.jsx)("a", __assign({ href: href, target: linkNewWindow ? "_blank" : "" }, { children: text }))
                :
                    text, (0, jsx_runtime_1.jsx)(Button_1.ButtonIcon, { symbol: IconSymbols_1.IconSymbols.Close, type: Button_1.ButtonTypes.LINK, size: enums_1.Enums.UiSizes.SM, className: "ml-auto", onClick: function () {
                    removeFn(itemId);
                } })] }));
};
exports.ListingItem = ListingItem;
